module.exports = __webpack_public_path__ + "06_long_grey.131b6e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_long_grey.png
// module id = x364
// module chunks = 0